<div class="payment-failed">
  <div class="payment-failed_heading">
    <stxt-svg-icon class="warning-icon" [iconConfig]="warningSvg" />
    <p>{{ error.errorTitle }}</p>
  </div>
  <p>
    {{ error.errorMessage }}
  </p>
</div>
